import * as React from 'react';
import cx from 'classnames';

const styles = require('./index.less');

export default class ScrollTop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false
    };
  }

  componentWillMount() {
    window.addEventListener('scroll', this.handleScroll, true);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll, true);
  }

  handleScroll = () => {
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollTop > 100) {
      this.setState({ show: true });
    } else {
      this.setState({ show: false });
    }
  };

  render() {
    return (
      <div
        className={cx(styles.scrollTop, this.state.show && styles.show)}
        onClick={() => {
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
        }}
      />
    );
  }
}
